<script setup lang="ts">
import { NotebookPenIcon } from 'lucide-vue-next'
import { useCollectsByStatus } from '~/composables/collect/useCollectsByStatus'
import { CollectStatus } from '~/types/graphql-backend-types/gql-types'

const { data: collectsToConfirm, isPending } = useCollectsByStatus(CollectStatus.RequestSent)
const { t } = useI18n()
const router = useRouter()

const handleCardClick = (action: string) => {
  router.push(action)
}
</script>

<template>
  <ActionCard
    :icon="NotebookPenIcon"
    :title="t('collect.new_collection_requests_to_confirm', { count: collectsToConfirm?.count })"
    :badge="{ title: t('documents.todo'), type: 'warning' }"
    button-action="/collects?status=requestSent"
    :button-label="t('global.see')"
    :is-loading="isPending"
    :is-visible="!!(collectsToConfirm?.count && collectsToConfirm?.count > 0)"
    @click="handleCardClick"
  />
</template>
